import { render, staticRenderFns } from "./public-layout.vue?vue&type=template&id=5a50f11a"
import script from "./public-layout.vue?vue&type=script&lang=js"
export * from "./public-layout.vue?vue&type=script&lang=js"
import style0 from "./public-layout.vue?vue&type=style&index=0&id=5a50f11a&prod&lang=css"
import style1 from "./public-layout.vue?vue&type=style&index=1&id=5a50f11a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports